import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FormFields } from '../../AccountForm.meta';
import { useAccountFormContext } from '../../context/useAccountFormContext';

export const CostBasis = () => {
  const { setAlert } = useAccountFormContext();

  const formBag = useFormContext<FormFields>();

  const [isLinked, isSyncCostBasisEnabled] = formBag.watch([
    'bankAccount.IsLinked',
    'bankAccount.SyncCostBasisEnabled',
  ]);

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.CostBasis"
      render={({ field: { onChange, ...field } }) => (
        <InputNumberMask
          {...field}
          leftIcon="fa fa-dollar-sign"
          allowNegative={false}
          decimalScale={2}
          label="Cost Basis"
          onChange={({ target: { value } }) => {
            if (isLinked && isSyncCostBasisEnabled) {
              setAlert({
                message: `Changing your cost basis will automatically un-sync sync
      cost basis for this account. To re-sync,
      toggle the sync cost basis toggle in the sync tab.`,
                type: 'info',
              });
            }
            onChange(value);
          }}
        />
      )}
    />
  );
};
